/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

"use client";
import { CosmosComponentContextProps } from "@cosmos/components";
import { PageSearchFragment } from "@cosmos/hygraph-schema";
import { SearchPage } from "@cosmos/search";
import { useLocale } from "@epic-mw/i18n";

import { TemplateProviders } from "../templates";

interface Props {
	pageData: PageSearchFragment;
	componentContext?: CosmosComponentContextProps;
}

export const CosmosPageSearch = ({ pageData, componentContext }: Props): React.JSX.Element => {
	const locale = useLocale();

	return (
		<TemplateProviders componentContext={componentContext}>
			<SearchPage {...pageData} locale={locale}></SearchPage>
		</TemplateProviders>
	);
};
